import { assistantGetterTypes } from './types'
import { ASSISTANT_FAILURES } from '@/consts/assistant'

const getters = {
    [assistantGetterTypes.GET_CONVERSATION_ID]: ({ conversationId }) =>
        conversationId,
    [assistantGetterTypes.GET_CLIENT_ID]: ({ clientId }) => clientId,
    [assistantGetterTypes.GET_MESSAGES]: ({ messages }) => messages,
    [assistantGetterTypes.GET_OUTGOING]: ({ outgoing }) => outgoing,
    [assistantGetterTypes.GET_TURN_STATE]: ({ turnState }) => turnState,
    [assistantGetterTypes.GET_PENDING]: ({ pending }) => pending,
    [assistantGetterTypes.GET_CLIENT_CANDIDATES]: ({ clientCandidates }) =>
        clientCandidates,
    [assistantGetterTypes.GET_WIG]: ({ wig }) => wig,
    [assistantGetterTypes.GET_IS_SENDING]: ({ isSending }) => isSending,
    [assistantGetterTypes.GET_FAILURE]: ({ failure }) => failure,
    [assistantGetterTypes.GET_IS_SWITCHED_OFF]: ({ isSwitchedOff }) =>
        isSwitchedOff,

    // Only a silent gateway is worth a retry — the rest answer the same however
    // many times they are asked.
    [assistantGetterTypes.GET_CAN_RETRY]: ({ failure, lastTurn }) =>
        !!lastTurn &&
        (failure?.type === ASSISTANT_FAILURES.GATEWAY_DOWN ||
            failure?.type === ASSISTANT_FAILURES.NETWORK),

    // Something to start over from.
    [assistantGetterTypes.GET_HAS_CONVERSATION]: ({
        conversationId,
        messages,
    }) => !!conversationId || messages.length > 0,
}

export default getters
